var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionConfirmationModal',{attrs:{"id":"refund-sale-modal","action":_vm.action,"confirmation-fields":_vm.confirmationFields,"loading":_vm.loading,"error-message":_vm.errorMessage},on:{"confirm":_vm.handleSubmit,"hidden":function($event){return _vm.$emit('hidden')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }